<template>
  <div ref="youtubeContainer" class="video-container">
    <div id="yt-player" />
  </div>
</template>

<script>
import { getYoutubeVideoID } from '../../utils.js';

export default {
  props: {
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    url: {
      type: String,
      default: '',
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    showControls: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      player: null,
    };
  },

  watch: {
    autoplay(newValue, oldValue) {
      console.log('Autoplay changed to: ', newValue);
      this.player.destroy();
      this.onYouTubeIframeAPIReady();
    },

    showControls(newValue, oldValue) {
      console.log('ShowControls changed to: ', newValue);
      this.player.destroy();
      this.onYouTubeIframeAPIReady();
    },

    url(newValue, oldValue) {
      console.log('Url changed to: ', newValue);
      this.player.destroy();
      this.onYouTubeIframeAPIReady();
    },
  },

  mounted() {
    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;

    if (
      document.querySelector(
        'script[src="https://www.youtube.com/iframe_api"]'
      ) === null
    ) {
      const tag = document.createElement('script');

      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
      this.onYouTubeIframeAPIReady();
    }
  },

  methods: {
    onYouTubeIframeAPIReady() {
      // eslint-disable-next-line no-undef
      this.player = new YT.Player('yt-player', {
        height: this.height,
        width: this.width,
        videoId: getYoutubeVideoID(this.url),
        playerVars: {
          autoplay: this.autoplay ? 1 : 0,
          controls: this.showControls ? 1 : 0,
          rel: 0,
        },
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange,
        },
      });
    },

    onPlayerReady(event) {
      if (this.autoplay) {
        event.target.playVideo();
      }
    },

    onPlayerStateChange(event) {},
  },
};
</script>

<style lang="scss">
.video-container {
  position: relative;
  width: 100%;
  padding-bottom: min(56.25%, calc(100vh - 100px));
  height: 0;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    max-height: calc(100vh - 100px);
  }
}
</style>
